<div class="back-to-scheduler-container" routerLink="/scheduler/calendar">
  <span class="back">BACK TO SCHEDULER</span>
  <div
    class="rounded-btn-prev"
    role="button"
    inlineSVG="/assets/icons/prev.svg"
  ></div>
</div>
